import { utility, getUserInfo } from './utility';

// 设备ID
let xd = '';
// 用户ID
let uid = '';

/**
 * 神策上报
 * @param {String} errorMessage 错误原因
 * @param {String} sourceType 场景
 * @param {String} times 初始化时长
 * @param {Number} status 初始化状态
 */
const report = function (errorMessage, sourceType, times, status) {
  const table = 'risk_tongdun_init';
  window.KEWLSensor.register(table, {
    xd: '', // 设备ID
    uid: '', // 用户ID
    error_message: '', // 错误原因
    source_type: '', // 场景("login" or "account_creation")
    times: 0, // 初始化时长(毫秒级时间)
    status: 0 // 初始化状态(1:成功, 2:失败)
  });
  window.KEWLSensor.track(table, {
    xd,
    uid,
    error_message: errorMessage,
    source_type: sourceType,
    times,
    status
  });
};

/**
 * 同盾上报
 * @param {AxiosRequestConfig} config axios config
 */
const tongdunReport = async (config) => {
  const td = localStorage.getItem('tongdunBlackBox') || '';
  // 登录、注册场景上报
  if ((!td || td.length > 1024) && config.url.toLowerCase().indexOf('channel/login') > -1) {
    if (!xd && !uid) {
      try {
        const userInfo = await getUserInfo();
        if (userInfo && (userInfo.userId || userInfo.user.uid)) {
          uid = userInfo.uid || userInfo.user.uid || '';
          xd = userInfo.xd || userInfo.user.xd || '';
        }
      } catch (e) {
        console.log(e);
      }
    }
    if (!xd) {
      let uuid = utility.getCookie('uuid');
      console.info(uuid);
      if (!uuid) {
        uuid = utility.createUUID();
        utility.setCookie('uuid', uuid, {
          expires: 365
        });
      }
      xd = uuid;
    }

    // 错误信息
    let errMsg = '';
    const time = window.TONGDun ? window.TONGDun.time || {} : {};
    if (!window.TONGDun) { // window.TONGDun不存在
      errMsg = 'window.TONGDun is undefind';
    } else if (time.ableTime) { // 同盾值已获取
      if (td.length > 1024) { // 同盾值过长
        errMsg = 'token too long';
      } else { // 例如ableTime有，但是localstorage没有tongdunBlackBox
        errMsg = 'other';
      }
    } else if (!time.initTime) { // 开始时间不存在(未调用init)
      errMsg = 'uninitialized';
    } else if (!time.fmLoaded) { // fm.js未加载完成
      errMsg = 'fm.js unload';
    } else { // 结束时间不存在(回调未执行)
      errMsg = 'unfinished';
    }
    // 用来标识登录还是注册
    let keep;
    if (typeof config.data === 'string') {
      let splitArr;
      config.data.split('&').some((item) => {
        splitArr = item.split('=');
        if (splitArr[0] === 'keep' && splitArr[1]) {
          // eslint-disable-next-line prefer-destructuring
          keep = splitArr[1];
          return true;
        }
        return false;
      });
    } else if (Object.prototype.toString.call(config.data) === '[object FormData]') {
      keep = config.data.get('keep');
    } else if (typeof config.data === 'object') {
      // eslint-disable-next-line prefer-destructuring
      keep = config.data.keep;
    }
    // 场景
    const sourceType = keep == 1 ? 'account_creation' : 'login';
    // 初始化时长
    const times = time.initTime && time.ableTime ? time.ableTime - time.initTime : 0;
    // 同盾初始化状态
    const status = time.ableTime ? 1 : 2;
    report(errMsg, sourceType, times, status);
  }
};

export default tongdunReport;
